import {domCreate} from "./helpers";

import "./InfoboxControl.css";

export type InfoboxOptions = {
    title?: string;
    strasse?: string;
    plz?: string;
    stadt?: string;
}

const defaultOptions = {
    title: null,
    strasse: null,
    plz: null,
    stadt: null,
}

export class InfoboxControl {
    protected _map?: maplibregl.Map;
    protected _container?: HTMLDivElement;
    private _options: InfoboxOptions;
    private _title: HTMLDivElement;
    private _address: HTMLDivElement;

    constructor(options) {
        this._options = Object.assign({}, defaultOptions, options)
    }

    canShow() {
        return !!(this._options.title || this._options.strasse || (this._options.strasse && this._options.plz && this._options.stadt))
    }

    onAdd(map) {
        this._map = map;
        this._container = domCreate('div', 'maplibregl-ctrl maplibregl-ctrl-group mapboxgl-ctrl mapboxgl-ctrl-group maplibregl-plugin-infobox')

        if (this._options.title || this._options.strasse) {
            this._title = domCreate('div', 'maplibregl-plugin-infobox-title', this._container)
            this._title.textContent = this._options.title || this._options.strasse
        }
        if (this._options.strasse && this._options.plz && this._options.stadt) {
            this._address = domCreate('div', 'maplibregl-plugin-infobox-address', this._container)
            this._address.textContent = this._options.strasse + ', ' + this._options.plz + ' ' + this._options.stadt
        }

        return this._container;
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }

    getDefaultPosition() {
        return 'top-left';
    }

}
